import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiFetch } from '@shared/api/http'
import { CurrentUserSchema, UserProfileInputSchema } from './user.contract'
import { userKeys } from './user.queries'
import type { CurrentUser, UserProfileInput } from './user.contract'

export async function updateUserProfile(input: UserProfileInput): Promise<CurrentUser> {
  const payload = UserProfileInputSchema.parse(input)
  const data = await apiFetch<unknown>('/users/profile', {
    method: 'PUT',
    body: payload,
  })
  return CurrentUserSchema.parse(data)
}

export function useUpdateUserProfileMutation() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateUserProfile,
    onSuccess: (user) => {
      queryClient.setQueryData(userKeys.me, user)
    },
  })
}
